
import React from 'react';
import Layout from '@/components/Layout/Layout';
import ServiceAreaMap from '@/components/Locations/ServiceAreaMap';
import ServiceAreaStats from '@/components/Locations/ServiceAreaStats';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { CalendarClock, FileText, PanelRight } from 'lucide-react';

const ServiceAreas = () => {
  return (
    <Layout>
      <div className="container mx-auto py-12 px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">Service Areas</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Carolina Trophy Roofs serves homeowners and businesses across Eastern North Carolina 
            with expert roofing services. Find your location below to learn more.
          </p>
        </div>

        <ServiceAreaStats />
        
        <div className="my-12">
          <ServiceAreaMap />
        </div>
        
        <div className="bg-gray-50 rounded-lg p-8 my-12">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold mb-4">Need Roofing Services in Your Area?</h2>
            <p className="text-xl text-gray-600">
              We provide free consultations and estimates for all roofing services throughout Eastern North Carolina.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white p-6 rounded-lg text-center shadow-sm">
              <div className="inline-block p-3 rounded-full bg-primary/10 mb-4">
                <CalendarClock className="h-8 w-8 text-primary" />
              </div>
              <h3 className="text-xl font-bold mb-2">Schedule a Consultation</h3>
              <p className="text-gray-600 mb-4">
                Book a free, no-obligation roof inspection and consultation with our experts.
              </p>
              <Link to="/contact">
                <Button>Request a Consultation</Button>
              </Link>
            </div>
            
            <div className="bg-white p-6 rounded-lg text-center shadow-sm">
              <div className="inline-block p-3 rounded-full bg-primary/10 mb-4">
                <FileText className="h-8 w-8 text-primary" />
              </div>
              <h3 className="text-xl font-bold mb-2">View Our Gallery</h3>
              <p className="text-gray-600 mb-4">
                See examples of our roofing projects in your community and across Eastern NC.
              </p>
              <Link to="/gallery">
                <Button variant="outline">Browse Gallery</Button>
              </Link>
            </div>
            
            <div className="bg-white p-6 rounded-lg text-center shadow-sm">
              <div className="inline-block p-3 rounded-full bg-primary/10 mb-4">
                <PanelRight className="h-8 w-8 text-primary" />
              </div>
              <h3 className="text-xl font-bold mb-2">About Our Services</h3>
              <p className="text-gray-600 mb-4">
                Learn more about our full range of residential and commercial roofing services.
              </p>
              <Link to="/services">
                <Button variant="outline">Explore Services</Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ServiceAreas;
